import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import EmployeesGroupDetailsBookings from 'src/features/employees-groups/components/templates/employees-group-details/bookings';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute(
  '/_layout/tenant/employees/groups/$groupToken/_layout/bookings',
)({
  component: EmployeesGroupDetailsBookings,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
